// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3OrNT","search":"styles_search__30J53","iconButton":"styles_iconButton__3elug","keysTable":"styles_keysTable__32BIE"};